import { baseApi } from 'services/baseApi';
import { AppConstants } from 'constants/index';
import {
  PaymentParams,
  PlayerParams,
  PaymentResponse,
  BetResponse,
  BetParams,
  PlayerBonusResponse,
  PlayerBonusParams,
  PlayerResponse,
} from 'app/quickSearch/types';

export const quickSearchApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPlayerSearchResult: builder.query<PlayerResponse, PlayerParams>({
      query: ({ skipGlobalLoading, ...params }) => {
        const { ReportingAdmin, QuickSearch, Players } = AppConstants.api;
        return {
          url: [ReportingAdmin, QuickSearch, Players],
          meta: { skipGlobalLoading },
          params,
        };
      },
    }),
    getPaymentSearchResult: builder.query<PaymentResponse, PaymentParams>({
      query: ({ skipGlobalLoading, ...params }) => {
        const { ReportingAdmin, QuickSearch, PaymentRequest } = AppConstants.api;
        return {
          url: [ReportingAdmin, QuickSearch, PaymentRequest],
          meta: { skipGlobalLoading },
          params,
        };
      },
    }),
    getBetSearchResult: builder.query<BetResponse, BetParams>({
      query: ({ skipGlobalLoading, ...params }) => {
        const { ReportingAdmin, QuickSearch, Bet } = AppConstants.api;
        return {
          url: [ReportingAdmin, QuickSearch, Bet],
          meta: { skipGlobalLoading },
          params,
        };
      },
    }),
    getPlayerBonusSearchResult: builder.query<PlayerBonusResponse, PlayerBonusParams>({
      query: ({ skipGlobalLoading, ...params }) => {
        const { ReportingAdmin, QuickSearch, Bonus } = AppConstants.api;
        return {
          url: [ReportingAdmin, QuickSearch, Bonus],
          meta: { skipGlobalLoading },
          params,
        };
      },
    }),
  }),
});

export const {
  useLazyGetPlayerSearchResultQuery,
  useLazyGetPaymentSearchResultQuery,
  useLazyGetBetSearchResultQuery,
  useLazyGetPlayerBonusSearchResultQuery,
} = quickSearchApi;
